import { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const LANGUAGES = {
  de: { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  en: { code: 'en', name: 'English', flag: '🇬🇧' },
  it: { code: 'it', name: 'Italiano', flag: '🇮🇹' }
};

export const DEFAULT_LANGUAGE = 'de';

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('helmut_language');
    return saved && LANGUAGES[saved] ? saved : DEFAULT_LANGUAGE;
  });

  useEffect(() => {
    localStorage.setItem('helmut_language', language);
    document.documentElement.lang = language;
  }, [language]);

  const t = (translations) => {
    if (!translations) return '';
    return translations[language] || translations[DEFAULT_LANGUAGE] || '';
  };

  const getLocalizedField = (item, fieldBase) => {
    if (!item) return '';
    const fieldName = `${fieldBase}_${language}`;
    return item[fieldName] || item[`${fieldBase}_${DEFAULT_LANGUAGE}`] || item[`${fieldBase}_en`] || '';
  };

  return (
    <LanguageContext.Provider value={{ 
      language, 
      setLanguage, 
      t, 
      getLocalizedField,
      languages: LANGUAGES 
    }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
